import { render, staticRenderFns } from "./LessonEditor.vue?vue&type=template&id=00920084"
import script from "./LessonEditor.vue?vue&type=script&lang=js"
export * from "./LessonEditor.vue?vue&type=script&lang=js"
import style0 from "./LessonEditor.vue?vue&type=style&index=0&id=00920084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports